import CountryService from '@/services/Countries/CountriesService';

const state = {
  current: {},
  countries: []
};

const actions = {
  getCountries ({commit}) {
    return CountryService.getCountries().then(result => {
      commit('setCountries', result.data);
    });
  },
  save (_, data) {
    if (data.oldCode) {
      return CountryService.editCountry(data.oldCode, data.country).then(() => {});
    }
    return CountryService.createCountry(data.country).then(() => {});
  },
  current ({commit}, data) {
    commit('current', data);
  }
};

const mutations = {
  setCountries(state, data) {
    state.countries = data;
  },
  current(state, data) {
    state.current = data;
  }
};

const getters = {
  countries(state) {
    return state.countries;
  },
  current(state) {
    return state.current;
  }
};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
};
